import React, { useState } from "react";
import { Box, BottomNavigation, BottomNavigationAction } from "@mui/material";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const StickyBottomNav = () => {
  const [value, setValue] = useState(0);

  return (
    <Box sx={{ width: "100%", position: "fixed", bottom: 0, zIndex: 1000 }}>
      <BottomNavigation
        sx={{
          backgroundColor: "var(--firstbackground)", // Main background
          boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.2)",
        }}
        showLabels
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
      >
        <BottomNavigationAction
          label="Recents"
          icon={<RestoreIcon />}
          sx={{
            color: "white", // Default text color
            "&.Mui-selected": {
              color: "var(--basecolor)", // Highlighted color
            },
          }}
        />
        <BottomNavigationAction
          label="Favorites"
          icon={<FavoriteIcon />}
          sx={{
            color: "white", // Default text color
            "&.Mui-selected": {
              color: "var(--basecolor)", // Highlighted color
            },
          }}
        />
        <BottomNavigationAction
          label="Nearby"
          icon={<LocationOnIcon />}
          sx={{
            color: "var(--basecolor)", // Default text color
            "&.Mui-selected": {
              color: "var(--basecolor)", // Highlighted color
            },
          }}
        />
      </BottomNavigation>
    </Box>
  );
};

export default StickyBottomNav;
